import axios from "axios";
import * as https from 'https';

const Axios = {
  install: function(Vue) {
    Vue.prototype.$http = axios.create({
      baseURL: process.env.VUE_APP_PUNTOPAY_URL,
      timeout: 60000,
      httpsAgent: new https.Agent({  
        rejectUnauthorized: false
      })
    });
  }
};

export default Axios;
